<script setup lang="ts">
import {resolveMediaUrl} from '~/utils/relations'

const perksFetch = usePerks()

const {pending, data: perks} = await useAsyncData('perks', () => perksFetch.fetch())
</script>

<template>
  <CareersSection
    v-if="perks && !pending"
    :title="$t('careers.perks.title')"
    :eyebrow="$t('careers.perks.eyebrow')"
    :intro="$t('careers.perks.intro')"
    section-id="perks-section"
    class="z-10 px-2 xs:px-0"
  >
    <div class="grid gap-4 xs:grid-cols-2 sm:gap-8 lg:grid-cols-3 xl:grid-cols-4">
      <CareersPerk
        v-for="item of perks"
        :key="item.title"
        :title="item.title"
        :description="item.description"
        :icon="resolveMediaUrl(item.icon) ?? ''"
      />
    </div>
  </CareersSection>
</template>
